import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography } from 'antd';
import { ProjectDto } from '@/core';
import { SheetCard } from './SheetCard';
import classes from './SheetCardsList.module.scss';
import classesCard from '../../../components/ProjectsConstructorCard/ProjectsConstructorCard.module.scss';

type PropsType = {
  projectData: ProjectDto;
};

export const SheetCardsList = ({ projectData }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [editedCardsIds, setEditedCardsIds] = useState<string[]>([]);

  const handleClickEdit = (id: string) => setEditedCardsIds((prev) => [...prev, id]);
  const handleStopEditCard = (id: string) =>
    setEditedCardsIds((prev) => prev.filter((editedCardId) => editedCardId !== id));

  return (
    <div className={classes.cardsList}>
      <Row className={classes.cardsListTitle}>
        <Col xs={8} md={6}>
          <Typography.Text>{t('addSheets.name')}</Typography.Text>
        </Col>
        <Col xs={8} md={9}>
          <Typography.Text>{t('addSheets.tables')}</Typography.Text>
        </Col>
        <Col xs={8} md={9}>
          <Typography.Text>{t('addSheets.epics')}</Typography.Text>
        </Col>
      </Row>
      {projectData.sheets.map((sheet) => (
        <SheetCard
          key={sheet.id}
          onClickMenuEdit={() => handleClickEdit(sheet.id)}
          isEdit={editedCardsIds.includes(sheet.id)}
          stopEditCard={() => handleStopEditCard(sheet.id)}
          projectData={projectData}
          {...sheet}
        />
      ))}
      <Row className={classesCard.cardWrapper}>
        <Col span={6}>
          <Typography.Text>{t('addSheets.total')}</Typography.Text>
        </Col>
        <Col span={18}>
          <Typography.Text>{t('addSheets.totalDescription')}</Typography.Text>
        </Col>
      </Row>
    </div>
  );
};
